import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { LIVE_CHAT_CONVERTER_TOKEN, LiveChatConverter } from './live-chat.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        liveChatFeature: {
          module: () => import('./live-chat.module').then((m) => m.LiveChatModule),
          cmsComponents: ['chatbot_miltenyi', 'chatbot_miltenyi_global', 'chatbot_miltenyi_internal'],
        },
      }
    }),
    {
      provide: LIVE_CHAT_CONVERTER_TOKEN,
      useExisting: LiveChatConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        chatbot_miltenyi: LIVE_CHAT_CONVERTER_TOKEN,
        chatbot_miltenyi_global: LIVE_CHAT_CONVERTER_TOKEN,
        chatbot_miltenyi_internal: LIVE_CHAT_CONVERTER_TOKEN,
      },
      multi: true
    }
  ]
})
export class LiveChatFeatureModule {}
